import "./SurveyResultsList.scss";

import { Avatar, Divider, Flex, Text } from "@fluentui/react-northstar";
import { Question, QuestionType, TeamsSurveyResponse } from "@teams/types";
import { SurveyDTO, SurveyResponsesDTO } from "@teams/types/api";
import moment from "moment";
import React from "react";

import { useUserResponseValue } from "../hooks/useUserResponeValue";

type Props = {
  survey: SurveyDTO;
  results: SurveyResponsesDTO;
};

export const SurveyResultsList: React.FC<Props> = ({ survey, results }) => {
  return (
    <Flex column gap="gap.medium" className="top-container">
      <Text content={survey.title} align="start" className="survey-title" />
      <Text content={survey.description} align="start" className="survey-description" />

      {results.responses.length === 0 && (
        <Text content="No Responses" align="center" size="large" weight="bold" />
      )}

      {results.responses.map(response => (
        <Flex key={response.id} column gap="gap.small" className="result-card">
          <Flex vAlign="center" className="result-card__header">
            <Flex gap="gap.smaller" vAlign="center">
              {survey.anonymity !== "anonymous" && (
                <Avatar
                  name={response.user.name}
                  size="small"
                  className="result-card__header__avatar"
                />
              )}
              <Text content={response.user.name} weight="bold" />
            </Flex>

            <Flex.Item push>
              <Text
                content={moment(response.createdAt).format("h:mm A")}
                className="result-card__header__timestamp"
              />
            </Flex.Item>
          </Flex>
          {survey.questions.map((question, index) => (
            <Flex gap="gap.medium" column>
              <UserQuestionResponse
                key={`${question.id}_${response.id}`}
                showQuestionTitle={survey.questions.length > 1}
                question={question}
                index={index + 1}
                response={response}
              />
              {index < survey.questions.length - 1 && <Divider fitted color="black" />}
            </Flex>
          ))}
        </Flex>
      ))}
    </Flex>
  );
};

const UserQuestionResponse: React.FC<{
  showQuestionTitle: boolean;
  question: Question<QuestionType>;
  index: number;
  response: TeamsSurveyResponse;
}> = ({ showQuestionTitle, question, index, response }) => {
  const userResponseValue = useUserResponseValue(question, response);

  return (
    <Flex column gap="gap.small" className="question-container">
      {showQuestionTitle && (
        <Text content={`${index}. ${question.label}`} className="question-container__question" />
      )}
      {userResponseValue ? (
        <Text content={userResponseValue} className="question-container__answer" />
      ) : (
        <Text content="(Not answered)" className="question-container__no-answer" />
      )}
    </Flex>
  );
};
